import { FreeTrial as GuestPassRecipient } from '@mc/api'
import { useFreeTrial } from '@mc/free-trial'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import CTA from 'components/CTA'
import { checkoutCtaTrackProps } from '../../utils/events'
import { HeroContainer } from './HeroContainer'
import { HeroTitle } from './HeroTitle'
import { RecipientLegalText } from './RecipientLegalText'

export const RecipientHero = () => {
  const { trial } = useFreeTrial()
  const { t } = useTranslation('@mc/next')

  return (
    <HeroContainer>
      <div className='row no-gutters d-flex justify-content-center'>
        <div className='col-12 col-md-10 col-lg-8'>
          <div className='mc-mt-12'>
            <HeroTitle guestPass={trial as GuestPassRecipient} />

            <RecipientLegalText />

            <CTA
              href={paths.checkout}
              className='mc-px-10'
              trackProps={checkoutCtaTrackProps}
            >
              {t('guestPass.claim.cta')}
            </CTA>
          </div>
        </div>
      </div>
    </HeroContainer>
  )
}
